export default __webpack_public_path__ + "static/media/karier_jogja.ca3641c8.jpg";